import { Tabs, Typography } from 'antd'

import { BatchSchoolsTab } from './tabs/BatchSchoolsTab/BatchSchoolsTab'

const BatchDashboardPage = () => {
    return (
        <>
            <Typography.Title>Batch Scripts</Typography.Title>
            <Tabs style={{ padding: '20px' }}>
                <Tabs.TabPane tab="School Setup" key="schools">
                    <BatchSchoolsTab />
                </Tabs.TabPane>
            </Tabs>
        </>
    )
}

export default BatchDashboardPage
